module.exports = __webpack_public_path__ + "img/product_logo_mobile.1f36a3ce.png";